/**
 * DEVNOTE: StencilJs klarer ikke å lese inn .env.
 * Eneste måte å differensiere er hvorvidt bygge er av type prod eller development.
 * Verdien setter i runtime i process.env.NODE_ENV. Det er kun process.env.NODE_ENV som vil ha verdi.
 * Kontra: man må kjøre stenciljs med --dev param for at process.env.NODE_ENV skal ha verdi 'Development'.
 * process.env.NODE_ENV har alltid verdi 'Production' i Azure uansett build.
 */

export const config = {
  ['dev_old']: {
    API_URL_NO: 'https://patentstyret-xp7test.enonic.cloud/_/service/no.seeds.patentstyret/get-stenciljs-components',
    API_URL_EN: 'https://patentstyret-xp7test.enonic.cloud/en/_/service/no.seeds.patentstyret/get-stenciljs-components',
  },
  ['dev']: {
    ENV: 'Development',
    API_URL_NO: 'https://patentstyret-xp7prod.enonic.cloud/_/service/no.seeds.patentstyret/get-stenciljs-components',
    API_URL_EN: 'https://patentstyret-xp7prod.enonic.cloud/en/_/service/no.seeds.patentstyret/get-stenciljs-components',
  },
  ['prod']: {
    API_URL_NO: 'https://www.patentstyret.no/_/service/no.seeds.patentstyret/get-stenciljs-components',
    API_URL_EN: 'https://www.patentstyret.no/en/_/service/no.seeds.patentstyret/get-stenciljs-components',
  },
};

export const getApiEndpoint = (env: 'prod' | 'dev', lang: 'en' | 'no') => {
  if (lang === 'en') {
    return config[env].API_URL_EN;
  } else {
    return config[env].API_URL_NO;
  }
};
